// Reusable 4x6 Grove case-pack label (UPC-A + carton SSCC barcodes); mapped identity.
// Generated by scripts/wms/generate.ts for PHP-417. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomGroveCasePackLabelFileDataSchema = yup.object().shape({
  customerDisplayName: yup.string().nullable().optional(),
  shipFromAddress: yup.string().nullable().optional(),
  groveFcLocation: yup.string().nullable().optional(),
  shipToAddress: yup.string().nullable().optional(),
  grovePoNumber: yup.string().nullable().optional(),
  grossWeight: yup.string().nullable().optional(),
  weightUom: yup.string().nullable().optional(),
  qtyPerCasePack: yup.string().nullable().optional(),
  vendorItemNumber: yup.string().nullable().optional(),
  groveSkuNumber: yup.string().nullable().optional(),
  productDescription: yup.string().nullable().optional(),
  countryOfOrigin: yup.string().nullable().optional(),
  expirationDate: yup.string().nullable().optional(),
  lotCode: yup.string().nullable().optional(),
  upc: yup.string().nullable().optional(),
  upcBarcode: yup.string().nullable().optional(),
  cartonSscc: yup.string().nullable().optional(),
  cartonSsccBarcode: yup.string().nullable().optional(),
})

export type BiomGroveCasePackLabelFileData = yup.InferType<
  typeof biomGroveCasePackLabelFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<BiomGroveCasePackLabelFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomGroveCasePackLabelFileMappings: RequiredFileData = {
  customerDisplayName: '353368bd-76bd-439f-91ff-fe5a79ef1d01',
  shipFromAddress: '063e45ef-ffa2-45eb-9a3e-df8e0d74a7d3',
  groveFcLocation: '7ac47016-19c8-414e-b8a2-39923365349c',
  shipToAddress: 'c5ca640d-2b85-471e-b116-2f8913c6b18a',
  grovePoNumber: 'bd02ca5b-f589-4a57-b1d1-9241f29ab666',
  grossWeight: '16abf6a6-f1b0-434b-bf41-bcddff9d2a3e',
  weightUom: '8da4cd2c-93df-4109-8931-d24805b36e8c',
  qtyPerCasePack: '3d6e4cb3-45b8-41a0-b033-3994e6777116',
  vendorItemNumber: '11307fb7-2cd0-47f6-a84d-f5fcdf2241bb',
  groveSkuNumber: 'b5a98081-d60c-4dfe-b7f4-59ff1714f80b',
  productDescription: 'b4d339d6-28ac-4606-ac96-494fdf919d64',
  countryOfOrigin: '0c18e8f7-5a15-45c1-82f9-050c7ce9e378',
  expirationDate: '403b373c-1628-4db6-9df2-f9d450a6508b',
  lotCode: 'e7ba87c8-d27f-4268-a221-a57c8da147d4',
  upc: '2a176df4-a951-4b07-a71e-6eb643c2f8b4',
  upcBarcode: 'fe091a4c-d50c-4a54-826b-0c88d0e0bc32',
  cartonSscc: '0db32d45-64e1-4ffd-863e-35e1cf9cf59c',
  cartonSsccBarcode: 'f2700476-3e37-436c-833b-311dd8743931',
}
